import React from 'react';
import { Field, useForm, useFormState } from 'react-final-form';
import { Grid } from '@material-ui/core';

import FieldWrapper from '@common/form/FieldWrapper';
import RadioInput from '@common/Radio/RadioInput';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Companies from './components/Companies';
import PsaDropDown from './components/PsaDropDown';

import useStyles from './styles';

const UserCompanies = ({ isHide }) => {
  const classes = useStyles();
  const { values } = useFormState({ subscription: { values: true } });
  const { change } = useForm();

  return (
    <div className={cx(classes.container, { [classes.hide]: isHide })}>
      <Grid container>
        <Grid item xs={12}>
          <FieldWrapper
            label="Customer Visibility"
            labelSize={12}
            contentSize={12}
            fullWidth
            classNameContainer={classes.crmIdField}
            content={
              <div>
                <Field
                  name="companyToggle"
                  id="companyToggle"
                  component={RadioInput}
                  choices={[
                    {
                      label: 'View all Customers',
                      value: 'false',
                    },
                    {
                      label: 'Limit to Specific Customers',
                      value: 'true',
                    },
                  ]}
                  onChangeCallBack={value => {
                    if (value === 'false' && values.crmCompanies.length) {
                      change('crmCompanies', []);
                    }
                  }}
                />
                <Field
                  id="crmId"
                  name="crmId"
                  component={PsaDropDown}
                  size="small"
                  labelName="name"
                  valueName="id"
                  disabled={values.companyToggle === 'false'}
                />
              </div>
            }
          />
        </Grid>
        {!!values.crmCompanies.length && (
          <Grid item xs={12}>
            <Companies />
          </Grid>
        )}
      </Grid>
    </div>
  );
};

UserCompanies.propTypes = {
  isHide: PropTypes.bool,
};
export default UserCompanies;
